export default __webpack_public_path__ + "static/media/pattern-hills.815d688f.svg";